import React, { useState } from 'react';
import { useController } from './controller';
import * as S from './styles';
import { translations, LanguageKeys } from './translation';
import DefaultLoadingFit from '../DefaultLoadingFit';

const PremiumPopUp = (props: { setActive: Function, active: boolean }) => {
    const controller = useController();

    return props.active && props.active == true ? (
        <S.main>
            <S.modal>
                <S.header>
                    <S.headerTitle>✨ LearnArez Premium</S.headerTitle>
                    <S.close icon={controller.general.icons.faXmark} onClick={() => {
                        props.setActive(false);
                    }} />
                </S.header>
                <S.textArea>
                    <S.textAreaTitle>
                        {translations[controller.currentLanguage].title}
                    </S.textAreaTitle>
                    {(Object.keys(translations[controller.currentLanguage].advantages) as Array<keyof typeof translations[typeof controller.currentLanguage]['advantages']>).map((advantage, index) => (
                        <S.textRow key={index}>
                            <S.textIcon icon={controller.general.icons.faCheck} />
                            <S.text>{translations[controller.currentLanguage].advantages[advantage]}</S.text>
                        </S.textRow>
                    ))}
                </S.textArea>
                {/* <S.pricing>
                    {translations[controller.currentLanguage].pricing}
                </S.pricing> */}
                <S.ctaButton onClick={() => {
                    controller.getCheckoutSession()
                }}>
                    {!controller.buttonClicked ? translations[controller.currentLanguage].cta : <DefaultLoadingFit active={true} borderRadius={10} size={25} />}
                </S.ctaButton>
            </S.modal>
        </S.main>
    ) : null;
}

export default PremiumPopUp;